export function optionalLeadAttribution(
  source: unknown
): { lead_source?: string } {
  if (typeof source !== "string") return {};
  const normalized = source.trim();
  return normalized ? { lead_source: normalized } : {};
}
